import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../services/apiClient';
import AskAI from './AskAI';
import BridgeChat from '../components/BridgeChat';
import { ASKAI_PROPS } from '../askaiBridge';

// Mobile /ask. Renders the legacy in-app Ask AI or the external Front Desk bridge
// depending on the server ASK_AI_MODE flag (default legacy). Legacy is untouched.
export default function AskAIRoute() {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null);
  useEffect(() => { apiFetch('/askai/config').then(d => setMode(d?.mode || 'legacy')).catch(() => setMode('legacy')); }, []);

  if (mode === null) return <div className="page" style={{ padding: 20, color: '#6b7280' }}>Loading…</div>;
  if (mode !== 'bridge') return <AskAI />;
  return (
    <div className="page chat-page-full">
      <button className="chat-back-btn" onClick={() => navigate('/dashboard')}>‹ Back</button>
      <div style={{ flex: 1, minHeight: 0 }}><BridgeChat {...ASKAI_PROPS} /></div>
    </div>
  );
}
